import { apiClient } from '@/lib/api/client'
import type { Tag } from '@/types/entities'

export const tagApi = {
  getAllTags: async (): Promise<Tag[]> => {
    const response = await apiClient.get('/api/tags')
    return response.data
  },

  getTag: async (tagId: number): Promise<Tag> => {
    const response = await apiClient.get(`/api/tags/${tagId}`)
    return response.data
  },
}

